import { SessionData } from '@/app/session/lib'
import { ErrorData } from '@/components/GlobalErrorModal'
import { HistoryRecord } from '@/types/redirect'
import { atom } from 'jotai'
import { atomWithStorage, createJSONStorage } from 'jotai/utils'

interface LoginState {
	email: string | undefined
	password: string | undefined
}
export interface GlobalErrorProps {
	isOpen: boolean
	data: ErrorData
}
export const loginAtom = atom<LoginState>({ email: '', password: '' })
export const globalErrorAtom = atom<GlobalErrorProps>({ isOpen: false, data: { message: '' } })
const storage = createJSONStorage<Array<HistoryRecord>>(() => sessionStorage)
export const historyAtom = atomWithStorage<Array<HistoryRecord>>('history', [], storage)

const sessionStorageInstance = createJSONStorage<SessionData | null>(() => sessionStorage)
export const sessionAtom = atomWithStorage<SessionData | null>('phoenix-session', null, sessionStorageInstance)
